import { useState } from "react"
import { useApolloClient } from "@apollo/react-hooks"
import moment from "moment"

import { useTranslation } from "lib/i18n/translation"
import { useAccesses } from "lib/accesses"
import { useModal } from "lib/modal"
import { MUTATE_UNSUBSCRIBE_INFORMATION } from "lib/graphql"

import ConfirmTerminateMissYou from "./confirm-terminate-miss-you"

const ConfirmTerminateSucceed = () => {
	const { c } = useTranslation("common")
	const { subscription } = useAccesses()
	const client = useApolloClient()
	const [yourReasonsValue, setYourReasonsValue] = useState("")
	const [reasonSelected, setReasonSelected] = useState("")
	const { show } = useModal()


	const unsubscriptionReasons = [
		{ value: "tout-vu", label: c("reason-for-unsubscription-saw-all-movies") },
		{ value: "trop-plateformes", label: c("reason-for-unsubscription-subscribe-to-too-many-platforms") },
		{ value: "manque-temps", label: c("reason-for-unsubscription-short-on-time") },
		{ value: "problemes-techniques", label: c("reason-for-unsubscription-technical-issues") },
		{ value: "programmation", label: c("reason-for-unsubscription-movies-dont-suit") },
		{ value: "cout-eleve", label: c("reason-for-unsubscription-subscription-price-too-high") },
		{ value: "louer-acheter", label: c("reason-for-unsubscription-prefer-to-rent-buy") },
		{ value: "autres", label: c("reason-for-unsubscription-others") },
	]

	const confirmForm = async () => {
		client
			.mutate({
				mutation: MUTATE_UNSUBSCRIBE_INFORMATION,
				variables: {
					unsubscribeInformation: {
						subscriptionId: parseInt(subscription.id),
						hasCancelled: true,
						reason: reasonSelected,
						comment: yourReasonsValue,
					}
				},
				context: { clientName: "adminKinow" }
			})

		show({
			id: "confirm-terminate-miss-you",
			children: <ConfirmTerminateMissYou/>,
			className: "modal"
		})
	}

	return (
		<>
			<h2 className="main-title">{c("subscription-has-been-canceled")}</h2>
			<p className="introduction">{c("access-to-your-subscription-until")} <strong>{moment(subscription.dateExp).format("D MMMM YYYY")}</strong></p>
			<form aria-label={c("cancel-your-subscription")}>
				<legend class="hidden">{c("cancel-your-subscription")}</legend>
				<p className="excerpt">{c("reason-for-unsubscription")}</p>
				<ul className="radios collapsible-group" role="radiogroup">
					{
						unsubscriptionReasons.map((reason, index) => (
							<li key={reason.value}>
								<span className="radio-container">
									<input
										type="radio"
										name={`svod-remove-reasons-${reason.value}-${index}`}
										value={reason.value}
										aria-label={reason.label}
										checked={reason.value === reasonSelected}
										onChange={(e) => setReasonSelected(reason.value)}
										data-collapsible
									/>
									<span class="form-label">{reason.label}</span>
								</span>
							</li>
						))
					}
				</ul>
				<div class={`reasons-message collapsible ${reasonSelected ? "active" : ""}`}>
					<label>{c("reason-for-unsubscription-tell-us-more")}</label>
					<textarea
						name="svod-remove-reasons-message-69412c2177e77"
						value={yourReasonsValue}
						placeholder={c("reason-for-unsubscription-your-reasons")}
						maxlength="1000"
						aria-label="Message"
						onChange={(e) => setYourReasonsValue(e.target.value)}
					/>
					<p class="form-error">
						<span class="form-counter">{yourReasonsValue.length}</span><span class="form-total">/1000</span>
						</p>
				</div>
			</form>
			<div className="overlay-footer fixed">
				<nav className="buttons centered short">
					<a
						href="#"
						onClick={async (e) => {
							e.preventDefault();
							await confirmForm()
						}}
						rel="nofollow noopener"
						title={c("confirm-form")}
						data-overlay="#overlay-add-svod-to-cart-remove-3"
						className={`confirm-reasons ${!reasonSelected ? "disabled" : ""}`}
						aria-disabled={!reasonSelected}
						>
						{c("confirm-form")}
					</a>
				</nav>
			</div>
		</>
	)
}

export default ConfirmTerminateSucceed
